module.exports = __webpack_public_path__ + "img/AppStore@2x.13cd0922.png";